import React, { useEffect, useState } from "react";
import "../Css/Banner.css";
import { FaArrowDownLong } from "react-icons/fa6";
import BannerImg from "../aseets/img/bannerNew.png"
import { Link } from "react-router-dom";
import ShapeImg from "../aseets/img/curve.png"
import axios from "axios";
import { Container } from "react-bootstrap";


const BannerSection = () => {
  const [bannerImages, setBannerImages] = useState([]);
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/banner-images`);
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          setBannerImages([response.data[0]]); 
        }
      } catch (error) {
        console.error('Error fetching banner images:', error);
      }
    };

    fetchBannerImages();

    
  }, []);
  return (
    <React.Fragment>
           {/* <div >
            <img className="bannerImgHome" src= {`${process.env.REACT_APP_API_URL}/${bannerImages[0]?.bannerImage}`}alt="banner" />
        </div>
      <div className="bannerMainDiv">
     
        <div className="bannerDescription">
        <div className="bannerTitle">{bannerImages[0]?.Title}  </div>
        <div className="bannerDescriptionDiv">
        <div className="bannerDescriptionPera">
        {bannerImages[0]?.Description}
        </div>

       
        </div>
      
        </div>
      </div>
      <div className="banerShapeDiv">
        <img src={ShapeImg} alt="img" />
      </div> */}
    
    <div
    style={{
      backgroundImage: `url(${process.env.REACT_APP_API_URL}/${bannerImages[0]?.bannerImage})`,
      // backgroundImage: `url(${BannerImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position:"relative",
      
      width: '100%',
    }}
    className="mainDivBannerSection"
  >
   
   <Container>
   <div className="bannerMainDiv">
     
     <div className="bannerDescription">
     <div className="bannerTitle">{bannerImages[0]?.Title}  </div>
     <div className="bannerDescriptionDiv">
     <div className="bannerDescriptionPera">
     {bannerImages[0]?.Description}
     </div>

    
     </div>
   
     </div>
   </div>
   </Container>
   <img src={ShapeImg} alt="img" style={{position:"absolute",bottom:"-1px"}} />
  </div>
  {/* <div className="shapDiv">
        
      </div> */}
    </React.Fragment>
  );
};

export default BannerSection;
